export default "__VITE_ASSET__f864abe4__"